import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { GeneralService } from '../../services/general.service';
import { PersonService } from '../../services/person.service';
import { deepCopy } from '@angular-devkit/core/src/utils/object';

@Component({
    selector: 'galleryCompoment',
    templateUrl: './gallery.component.html',
    styleUrls: ['./gallery.component.scss']
})
export class GalleryComponent implements OnInit {

    dialogRef: MatDialogRef<any>;

    loading = false;

    person_id = 0;

    files = [];

    constructor(
        @Inject(MAT_DIALOG_DATA) public data,
        protected gs: GeneralService,
        protected personService: PersonService
    ) {
    }

    async ngOnInit() {
        this.loadPersonData();
    }

    closeModal() {
        this.dialogRef.close();
    }

    async loadPersonData() {
        this.person_id = this.data.person_id;

        this.loading = true;
        return await this.personService
            .loadCompany(this.data?.person_id)
            .then((result) => {
                this.files = (result?.files?.filter(item => item.gallery == 'public.person.site') || [])
                    .filter(item => ['jpeg', 'jpg', 'gif', 'png', 'webp'].indexOf(item.extension) > -1)
                    .map(item => {
                        return {
                            ...item,
                            large: this.gs.getFileName(item, 'large'),
                            thumb: this.gs.getFileName(item, 'thumb')
                        };
                    }) ?? [];
            })
            .catch((err) => { this.gs.error(err); })
            .finally(() => this.loading = false);

    }

    selFiles(item) {
        if (!item.files.at(0)?.thumb)
            return this.gs.error(null, 'Aguarde concluir o envio do arquivo');

        if (!!item.files?.length) {
            item.files = item.files.map(file => (
                {
                    ...file,
                    large: this.gs.getFileName(file, 'large'),
                    thumb: this.gs.getFileName(file, 'thumb')
                }
            ));
            this.gs.transactionData.next({ action: 'gallerySelecting', data: item.files.at(0) });
            this.closeModal();
        }

    }


}
